// import { responsiveArray } from "antd/lib/_util/responsiveObserve";
import { socketServer } from "../../assets/socketConnection";
import packageJson from "../../../package.json";
import {
  setAlertPageFirstBtn,
  setAlertPageMessage,
  toggleAlertPageIsVisible,
} from "../alertPage/alertPage.actions";
import { setUserToken } from "../user/user.actions";

import loginTypes from "./login.types";
import sizeComponent from "../../containerSmall/size/size.component";

export const setLoginPhoneNumber = (phoneNumber) => ({
  type: loginTypes.SET_PHONE_NUMBER,
  payload: phoneNumber,
});
export const setLoginSentCode = (code) => ({
  type: loginTypes.SET_SENT_CODE,
  payload: code,
});

export const setLoginName = (name) => ({
  type: loginTypes.SET_NAME,
  payload: name,
});
export const setLoginMelli = (melli) => ({
  type: loginTypes.SET_MELLI,
  payload: melli,
});
export const setReferralMobile = (mobile) => ({
  type: loginTypes.SET_REFERALL_MOBILE,
  payload: mobile,
});
export const setUserTOKEN = (token) => ({
  type: loginTypes.SET_USER_TOKEN,
  payload: token,
});
export const setUserCookie = (cookie) => ({
  type: loginTypes.SET_USER_COOKIE,
  payload: cookie,
});
export const setSurvey = (survey) => ({
  type: loginTypes.SET_SURVEY,
  payload: survey,
});

export const setPassword = (pass) => ({
  type: loginTypes.SET_PASSWORD,
  payload: pass,
});
export const setUsername = (username) => ({
  type: loginTypes.SET_USERNAME,
  payload: username,
});

export const setLoginStep = (step) => ({
  type: loginTypes.SET_LOGIN_STEP,
  payload: step,
});

export const setLoginPhoneNumberIsValid = (bool) => ({
  type: loginTypes.SET_LOGINPHONENUMBER_ISVALID,
  payload: bool,
});

// fetch phone login
export const fetchLoginPhoneStart = () => ({
  type: loginTypes.FETCH_LOGINPHONE_START,
});
export const fetchLoginPhoneSuccess = (msg) => ({
  type: loginTypes.FETCH_LOGINPHONE_SUCCESS,
  payload: msg,
});
export const fetchLoginPhoneFailure = (msg) => ({
  type: loginTypes.FETCH_LOGINPHONE_FAILURE,
  payload: msg,
});
//

// fetch phone login confirm
export const fetchLoginPhoneConfirmStart = () => ({
  type: loginTypes.FETCH_LOGINPHONECONFIRM_START,
});
export const fetchLoginPhoneConfirmSuccess = (msg) => ({
  type: loginTypes.FETCH_LOGINPHONECONFIRM_SUCCESS,
  payload: msg,
});
export const fetchLoginPhoneConfirmFailure = (msg) => ({
  type: loginTypes.FETCH_LOGINPHONECONFIRM_FAILURE,
  payload: msg,
});
//

// fetch phone login username
export const fetchLoginUserNameConfirmStart = () => ({
  type: loginTypes.FETCH_LOGINUSERNAMECONFIRM_START,
});
export const fetchLoginUserNameConfirmSuccuss = (obj) => ({
  type: loginTypes.FETCH_LOGINUSERNAMECONFIRM_SUCCESS,
  payload: obj,
});
export const fetchLoginUserNameConfirmFailure = (msg) => ({
  type: loginTypes.FETCH_LOGINUSERNAMECONFIRM_FAILURE,
  payload: msg,
});
export const setQueryObject = (obj) => ({
  type: loginTypes.SET_QUERY_OBJECT,
  payload: obj,
});
//

// async
export const fetchLoginPhoneAsync = () => (dispatch, getState) => {
  dispatch(fetchLoginPhoneStart());
  console.log("queryString2", getState().login.queryObject);
  const data = {
    mobile: getState().login.phoneNumber,
    client_information: {
      type: "web",
      version: packageJson.version,
      userAgent: navigator.userAgent,
      socketServer: socketServer,
    },
    queryObject: getState().login.queryObject,
  };
  // debugger;
  fetch(`${socketServer}users/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    // .then(() => document.body.classList.add("hide"))
    .then((res) => res.json())
    .then((res) => {
      console.log("barnet", res);
      dispatch(fetchLoginPhoneSuccess(res));
      dispatch(setLoginStep(1));
    })
    .catch((err) => dispatch(fetchLoginPhoneFailure(err.message)));
};

export const fetchLoginPhoneConfirmAsync =
  (browserHistory) => (dispatch, getState) => {
    dispatch(fetchLoginPhoneConfirmStart());

    const data = {
      mobile: getState().login.phoneNumber,
      code: getState().login.sentCode,
      client_information: {
        type: "web",
        version: packageJson.version,
        userAgent: navigator.userAgent,
        socketServer: socketServer,
      },
    };

    // debugger;

    // dispatch(
    //   setUserToken(
    //     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtb2JpbGUiOiIwOTEwMjExOTExOCIsImVtYWlsIjpudWxsLCJfaWQiOiI1ZWU3OWUxYzk0ZWQ3YTExNTA3OWM4YjMiLCJJc01lbWJlciI6dHJ1ZSwiaWF0IjoxNjQwMjQ1ODIzLCJleHAiOjE2NDI4Mzc4MjN9.zpH4j93jZMzhHLKhta0ST86DJ0ZNRn1dy1iYtPsFmI0"
    //   )
    // );

    function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    fetch(`${socketServer}users/login_confirm`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((res) => {
        dispatch(fetchLoginPhoneConfirmSuccess(res));
        // debugger;
        console.log("step2", Number(res.status));
        switch (Number(res.status)) {
          case 0:
            dispatch(setAlertPageMessage(res.detail));
            dispatch(setAlertPageFirstBtn("باشه"));
            dispatch(toggleAlertPageIsVisible());
            break;

          case 1:
            dispatch(setUserToken(res.Token));
            setCookie("token", res.Token, 30);
            window.location.href = `/app2/home`;
            break;

          case 2:
            dispatch(setUserToken(res.Token));
            setCookie("token", res.Token, 30);
            dispatch(setLoginStep(2));
            break;

          default:
            break;
        }
      })
      .catch((err) => dispatch(fetchLoginPhoneConfirmFailure(err.message)));
  };

export const fetchLoginNewUserAsync =
  (browserHistory) => (dispatch, getState) => {
    console.log("step2", getState().user.token);
    const data = {
      name: getState().login.name,
      national_code: getState().login.melli,
      referral_mobile: getState().login.referralMobile,
      survey: getState().login.survey,
      token: getState().user.token,
      client_information: {
        type: "web",
        version: packageJson.version,
        userAgent: navigator.userAgent,
        socketServer: socketServer,
      },
    };
    console.log("step2", data);
    fetch(`${socketServer}users/newuser_set_refer`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("step2", res);
        window.location.href = `/app2/home`;
      });
  };

export const fetchLoginUserNameAsync = () => (dispatch, getState) => {
  dispatch(fetchLoginUserNameConfirmStart());

  const data = {
    username: getState().login.userName,
    password: getState().login.password,
  };

  fetch(`${socketServer}users/gettoken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((res) => {
      dispatch(fetchLoginUserNameConfirmSuccuss(res));

      if (Number(res.status) === 0) {
        // debugger;
        dispatch(setAlertPageMessage(res.detail));
        dispatch(setAlertPageFirstBtn("باشه"));
        dispatch(toggleAlertPageIsVisible());
        return;
      }

      if (Number(res.status) === 1) {
        dispatch(setUserToken(res.Token));
        window.location.href = `/app2/home`;
        return;
      }
    })
    .catch((err) => dispatch(fetchLoginUserNameConfirmFailure(err.message)));
};
//
